import { useParams } from "react-router-dom";

// MUI
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";

// Material Kit
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

import routes from "routes";
import footerRoutes from "footer.routes";

import noticias from "data/noticiasData";

export default function NoticiaDetalle() {
  const { id } = useParams();
  const noticia = noticias.find((n) => n.id === parseInt(id));

  if (!noticia) {
    return <div>Noticia no encontrada</div>;
  }

  return (
    <>
      <DefaultNavbar routes={routes} transparent light />

      <MKBox bgColor="white">
        {/* HEADER IGUAL AL DE NOTICIAS */}
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage:
              'url("https://i.pinimg.com/1200x/39/b9/50/39b950d2eeef82f7a07092aebe51fafc.jpg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />

        {/* CARD CONTENEDOR */}
        <Card
          sx={{
            p: 4,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.9),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Grid container justifyContent="center">
            <Grid item xs={12} md={10} lg={8}>
              {/* TITULO */}
              <Typography variant="h2" fontSize={50} fontWeight="bold" color="black" mb={1}>
                {noticia.titulo}
              </Typography>

              {/* FECHA */}
              <Typography variant="caption" color="text.secondary" fontSize={20}>
                {noticia.fecha}
              </Typography>

              {/* EPIGRAFE */}
              <Typography variant="subtitle1" mt={2} mb={4}>
                {noticia.epigrafe}
              </Typography>

              {/* FOTO PRINCIPAL */}
              <MKBox
                component="img"
                src={noticia.foto}
                width="80%"
                display="block"
                mx="auto"
                borderRadius="lg"
                mb={4}
              />

              {/* CUERPO PARTE 1 */}
              {noticia.noticia.split("\n\n").map((parrafo, index) => (
                <Typography key={index} variant="body1" lineHeight={1.8} mb={3}>
                  {parrafo}
                </Typography>
              ))}

              {/* FOTO INTERMEDIA */}
              {noticia.foto2 && (
                <MKBox
                  component="img"
                  src={noticia.foto2}
                  width="80%"
                  display="block"
                  mx="auto"
                  borderRadius="lg"
                  my={4}
                />
              )}

              {/* CUERPO PARTE 2 */}
              {noticia.noticia2 && (
                <Typography variant="body1" lineHeight={1.8}>
                  {noticia.noticia2}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Card>

        {/* FOOTER */}
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </MKBox>
    </>
  );
}
